import React from "react";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { RotationSetup } from "./RotationSetup";
import { TestingPins } from "./PinPlacement/TestingPins";

export const PinsComponent = () => {
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const sideSubnavPinsData = () => {
    switch (mapSideNavTabState.get()) {
      case "Pin Placement":
        return <TestingPins />;
      case "Rotation Setup":
        return <RotationSetup />;
      default:
        return <></>;
    }
  };

  return <>{sideSubnavPinsData() && sideSubnavPinsData()}</>;
};
